import { mainHeaderFields } from './mainHeaderFields';
import { mainVehicleDetailsFields } from './mainVehicleDetailsFields';
import { manufacturingFields } from './manufacturingFields';
import { accessoryFields } from './accessoryFields';
import { companyCarFields } from './companyCarFields';
import { damagesFields } from './damagesFields';
import { dealerAssignmentFields } from './dealerAssignmentFields';
import { dealerInfoFields } from './dealerInfoFields';
import { disruptionsFields } from './disruptionsFields';
import { orderInfoFields } from './orderInfoFields';
import { pricingFields } from './pricingFields';
import { qualityConfirmationsFields } from './qualityConfirmationsFields';
import { regulatoryInformation } from './regulatoryInformationFields';
import { rootLevelFields } from './rootLevelFields';
import { soldOrderFields } from './soldOrderFields';
import { transportationDataFields } from './transportationDataFields';
import { vehicleAttrsFields } from './vehicleAttrsFields';
import { vehicleSpecsFields } from './vehicleSpecsFields';
import { vehicleSummaryFields } from './vehicleSummaryFields';
import { vehicleTrackingFields } from './vehicleTrackingFields';
import { logisticsFields } from './logisticsFields';
import { salesInfoFields } from './salesInfoFields';
import { vehicleHoldsFields } from './vehicleHoldsFields';

export const LABEL_VALUE_CONFIG = {
  ...mainHeaderFields,
  ...mainVehicleDetailsFields,
  ...manufacturingFields,
  ...accessoryFields,
  ...companyCarFields,
  ...damagesFields,
  ...dealerAssignmentFields,
  ...dealerInfoFields,
  ...disruptionsFields,
  ...orderInfoFields,
  ...pricingFields,
  ...qualityConfirmationsFields,
  ...regulatoryInformation,
  ...rootLevelFields,
  ...soldOrderFields,
  ...transportationDataFields,
  ...vehicleAttrsFields,
  ...vehicleSpecsFields,
  ...vehicleSummaryFields,
  ...vehicleTrackingFields,
  ...logisticsFields,
  ...salesInfoFields,
  ...vehicleHoldsFields,
};

export const AVAILABLE_FIELD_KEYS = Object.keys(LABEL_VALUE_CONFIG);
